<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="账号" prop="username">
        <el-input v-model="ruleForm.username"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="passwd">
        <el-input v-model="ruleForm.passwd"></el-input>
      </el-form-item>
      <el-form-item label="昵称" prop="nickname">
        <el-input v-model="ruleForm.nickname"></el-input>
      </el-form-item>
      <el-form-item label="医院" prop="hosipital">
        <el-input v-model="ruleForm.hosipital"></el-input>
      </el-form-item>
      <el-form-item label="科室" prop="department">
        <el-select v-model="value" placeholder="请选择" @change="changeDepartment">
          <el-option v-for="item in options" :value="item.department_name" :key="item.department_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input type="textarea" v-model="ruleForm.note"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">生成</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="账号生成成功" :visible.sync="dialogVisible" width="30%">
      <span>账号：{{ruleForm.username}}</span>
      <span>密码：{{ruleForm.passwd}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import global from '../Global';
  export default {
    name: "addTempUser",
    mounted() {
      let that = this;
      that.axios({
        method: 'GET',
        url: global.accountUrl + '/storkUser/findAllDepartment'
      })
        .then(
          function (response) {
            if (response.data.code == 200) {
              that.options = response.data.data;
            } else {
              that.$message.error('请求数据失败');
            }
          }
        )
    },
    data() {
      return {
        ruleForm: {
          username: '12345678910',
          passwd: '123456',
          nickname: '张医生',
          hosipital: '思多科医院',
          department: '超声科',
          note: '用于临床医生测试使用'
        },
        rules: {
          username: [
            { required: true, message: '请输入用户账号', trigger: 'blur' },
            { min: 11, max: 11, message: '格式为：XXXXXXXXXXX', trigger: 'blur' }
          ],
          passwd: [
            { required: true, message: '请输入用户密码', trigger: 'blur' },
            { min: 6, max: 15, message: '格式为：6-15任意字符', trigger: 'blur' }
          ],
          nickname: [
            { required: true, message: '请输入用户名称', trigger: 'blur' },
            { max: 15 }
          ],
          hosipital: [
            { required: true, message: '请输入医院名称', trigger: 'blur' }
          ],
          note: [
            { required: true, message: '请输入下载地址，格式为：1.优化图像质量,2.修复一些已知BUG', trigger: 'blur' },
          ]
        },
        options: [],
        value: '血管外科',
        departmentID: 1,
        dialogVisible: false
      };
    },
    methods: {
      submitForm(formName) {
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.axios({
              method: 'post',
              url: global.accountUrl + '/storkUser/addTmpUser',
              data: {
                username: that.ruleForm.username,
                nickname: that.ruleForm.nickname,
                password: that.ruleForm.passwd,
                department: that.departmentID,
                hospital: that.ruleForm.hosipital,
                note: that.ruleForm.note
              }
            })
              .then(function (response) {
                if (response.data.code == 200) {
                  that.dialogVisible = true;
                }
                else {
                  that.$message.error(response.data.data);
                }
              })
          } else {
            console.log('请填入正确的版本信息');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      changeDepartment(val) {
        let item = this.options.find((dd) => {
          return dd.department_name === val;
        });
        this.departmentID = item.department_id;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tempuser/AddTempUser.vue